import { connectedStore } from '../../store';
import actions from '../actions';

const removeLocale = (locale) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.removeLocale(locale, resolve, reject));
  });

export default removeLocale;
